import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import DropdownLayoutComponent from '../../layout-components/dropdown';

const Dropdown = styled(DropdownLayoutComponent)`
  &.ui.dropdown .menu .selected.item {
    background: none;
  }
  &.ui.dropdown .menu .selected.item:hover {
    background: rgba(0,0,0,.05);
  }
`;

const DropdownSpan = styled.span`
  color: ${(props) => (props.theme.color.textTitle)};
  margin-left: 10px;
`;

const ErrorMessage = styled(TextLayoutComponent.Error)``;

export {
  Dropdown,
  DropdownSpan,
  ErrorMessage,
};
